import {
  PAYMENT_TYPE_BY_ORG,
  SEARCH_VALUE_TYPE_BY_ORG,
} from 'pages/ProductsPages/constant'

export const ACTIVE_PRODUCT = 1
export const DISCONTINUED_PRODUCT = 2

export const LIST_TABS = [
  {
    id: ACTIVE_PRODUCT,
    label: 'IOperatingInstitutions',
  },
  // TODO: Uncomment when the feature is available
  // {
  //   id: DISCONTINUED_PRODUCT,
  //   label: 'INonOperatingInstitutions',
  // },
]

export const LIST_INSTITUTIONS = [
  {label: 'IHospitals', value: 'NORMAL'},
  {label: 'IExaminationCenter', value: 'HEALTH'},
]

export const LIST_COUNTRY = [
  {label: 'IKorea', value: 'Korea'},
  {label: 'IOverseas', value: 'Overseas'},
]

export const LIST_PRODUCT_TYPE = [
  {label: 'IRechargeOne', value: PAYMENT_TYPE_BY_ORG.PREPAID_ONCE},
  {label: 'IRechargeMonthly', value: PAYMENT_TYPE_BY_ORG.PREPAID_MONTHLY},
  {label: 'IManual', value: PAYMENT_TYPE_BY_ORG.MANUAL},
]

export const SEARCH_KEY = [
  {
    label: 'ICustomerOrganizationName',
    value: SEARCH_VALUE_TYPE_BY_ORG.ORG_NAME,
  },
  {label: 'IProductName', value: SEARCH_VALUE_TYPE_BY_ORG.GOODS_NAME},
  {label: 'IEmail', value: SEARCH_VALUE_TYPE_BY_ORG.EMAIL},
]

export const ProductOperationAgency = [
  {label: 'IAdminDesign', value: 'orgAppointed'},
  {label: 'IAnalysisLicense', value: 'freePayment'},
]
export const LIST_COLUMN = [
  {label: 'ItherapyId', key: '1'},
  {label: 'IOrgNameShort', key: '2'},
  {label: 'IAccount', key: '3'},
  {label: 'ICountry', key: '4'},
  {label: 'IProductNameSelect', key: '5'},
  {label: 'IType', key: '6'},
  {label: 'IUsePeriod', key: '7'},
  {label: 'IProductOperation', key: '8'},
  {label: 'IRemark', key: '9'},
]

export const LIST_COLUMN_V1 = [
  {label: 'ItherapyId', key: '1'},
  {label: 'IOrgNameShort', key: '2'},
  {label: 'IAccount', key: '3'},
  {label: 'ICountry', key: '4'},
  {label: 'IProductNameSelect', key: '5'},
  {label: 'IType', key: '6'},
  {label: 'IUsePeriod', key: '7'},
  {label: 'IRemark', key: '9'},
]

export const FAKE_DATA = [
  {
    id: 0,
    1: 3,
    2: '아이메디신_병원',
    3: 'tndusqn@gccorp.com',
    4: '한국',
    5: '아이메디신 분석 패키지_1',
    6: '아이메디신 분석 패키지_1',
    7: ' 2025-03-01~ 2026-02-28',
    8: 'Y',
    9: '',
  },
  {
    id: 1,
    1: 2,
    2: '아이메디신_병원',
    3: 'tndusqn@gccorp.com',
    4: '한국',
    5: '아이메디신 분석 패키지_1',
    6: '아이메디신 분석 패키지_1',
    7: ' 2025-03-01~ 2026-02-28',
    8: 'N',
    9: '',
  },
  {
    id: 2,
    1: 1,
    2: '아이메디신_병원',
    3: 'tndusqn@gccorp.com',
    4: '한국',
    5: '아이메디신 분석 패키지_1',
    6: '아이메디신 분석 패키지_1',
    7: ' 2025-03-01~ 2026-02-28',
    8: 'Y',
    9: '',
  },
]

export const initialParams = {
  page: 0,
  size: 10,
}

export const initialPayload = {
  domestic: true,
  paymentType: PAYMENT_TYPE_BY_ORG.PREPAID_ONCE,
  searchValueType: SEARCH_VALUE_TYPE_BY_ORG.ORG_NAME,
  searchValue: '',
  orgAppointed: false,
  freePayment: false,
  page: 0,
  size: 10,
  orgType: 'NORMAL',
}

export const LICENSE_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DESTROYED: 'DESTROYED',
}

export type LicenseStatus = keyof typeof LICENSE_STATUS
